exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".click-and-drag-block[data-v-7c414cb4]{width:100%;height:100%;position:absolute;transition:opacity .5s}.click-and-drag-block.hidden[data-v-7c414cb4]{opacity:0}.click-and-drag-block .click-and-drag[data-v-7c414cb4]{width:124px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1;pointer-events:none;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/motor-show/ClickAndDrag.vue?vue&type=style&index=0&id=7c414cb4&lang=scss&scoped=true&
// module id = gqyt
// module chunks = 8